export default {
	generador: "/generador",
	registro: "/registro",
	login: "/"
}